module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone-register-wrapper"
  }, [(_vm.stepShow) ? _c('div', {
    staticClass: "stepOneRegister"
  }, [_c('div', {
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row phone-input"
  }, [_c('p', {
    staticClass: "international-area-code"
  }, [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    staticClass: "form-input phone-number",
    attrs: {
      "type": "text",
      "name": "userName",
      "placeholder": _vm.$t('register.phone')
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t(_vm.phoneError)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "type": "text",
      "name": "code",
      "placeholder": _vm.$t('register.code')
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      'send-btn': _vm.sendBtn, 'disabled': _vm.disabled
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.timeText) + _vm._s(_vm.$t(_vm.valueText)))]), _vm._v(" "), _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t(_vm.codeError)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('register.password_set')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.savePwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t(_vm.passwordError)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('country-com', {
    attrs: {
      "lang": _vm.lang
    },
    model: {
      value: (_vm.countryInfo),
      callback: function($$v) {
        _vm.countryInfo = $$v
      },
      expression: "countryInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wapper"
  }, [_c('span', {
    staticClass: "checkbox",
    on: {
      "click": _vm.alocked
    }
  }, [(!_vm.checked) ? _c('i', {
    staticClass: "icon-box iconfont"
  }) : _c('i', {
    staticClass: "iconfont icon-checked"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#cccccc"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.protocol_a'))), _c('span', {
    staticClass: "checkbox-text",
    staticStyle: {
      "color": "#272f44"
    },
    on: {
      "click": _vm.registerService
    }
  }, [_vm._v(_vm._s(_vm.$t('register.protocol_b')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('button', {
    class: {
      'save-phone-btn': _vm.checked, 'no-save-phone-btn': !_vm.checked
    },
    attrs: {
      "disabled": !_vm.checked
    },
    on: {
      "click": _vm.savePwd
    }
  }, [_vm._v(_vm._s(_vm.$t('register.submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row login"
  }, [_c('p', [_c('span', {
    staticClass: "login-btn",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('register.login_now')) + " "), _c('span', {
    staticClass: "iconfont icon-login-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.stepShowTwo) ? _c('div', {
    attrs: {
      "id": "success"
    }
  }, [_c('div', {
    staticClass: "success-wapper"
  }, [_c('img', {
    staticClass: "success-img",
    attrs: {
      "src": require("../../assets/success.png"),
      "alt": "success"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('register.success')))]), _vm._v(" "), _c('div', {
    staticClass: "changeBtn"
  }, [_c('button', {
    staticClass: "login_btn",
    on: {
      "click": _vm.saveStepThree
    }
  }, [_vm._v(_vm._s(_vm.$t('register.login_re')))])])])]) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2765431e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2765431e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/phoneRegister/phoneRegister.vue
// module id = 416
// module chunks = 3